/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EFormSubmitResult {
  Success = 'success',
  Error = 'error'
}
